export default __webpack_public_path__ + "static/quality_main-6ba348497784d47bfc9176bd627480ce.webp";